import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNotify } from 'react-admin';
import AccordionActions from '@material-ui/core/AccordionActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import themes from '../theme';
import { updateTheme } from '../actions';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from './SettingsUtils';

const useStyles = makeStyles((theme) => ({
  settingsThemeContainer: {
    width: '50%',
    margin: '20px auto 0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 25px) !important',
      margin: '10px auto 0px auto !important',
    },
  },
  subText: {
    marginBottom: 5,
  },
  radioList: {
    marginLeft: 0,
    padding: '3px 0',
  },
  w100: {
    width: '100%',
  },
}));

const themeNames = themes.map((t) => t.name);

const FormLabels = () => {
  const classes = useStyles();
  return themeNames.map((name, index) => (
    <FormControlLabel
      key={name}
      value={index}
      control={<Radio />}
      label={name}
      className={classes.radioList}
    />
  ));
};

const ThemeSettings = () => {
  const classes = useStyles();
  const theme = useSelector((state) => state.settings.theme);
  const dispatch = useDispatch();
  const notify = useNotify();
  const [expanded, setExpanded] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(theme);
  const [showNotify, setShowNotify] = useState(false);

  useEffect(() => {
    if (showNotify) {
      setShowNotify(!showNotify);
      notify('Theme set successfully', 'info');
    }
  }, [showNotify, setShowNotify, notify]);

  const handleThemeChange = (event) => {
    if (event === 'cancel') {
      setSelectedTheme(theme);
    } else {
      dispatch(updateTheme(selectedTheme));
      setShowNotify(!showNotify);
    }
  };

  return (
    <div className={classes.settingsThemeContainer}>
      <ExpansionPanel
        square
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <ExpansionPanelSummary
          aria-controls="panel1d-content"
          expandIcon={<ExpandMoreIcon />}
          id="panel1d-header"
        >
          <Typography>Themes</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div className={classes.settingsThemeContainer}>
            <FormControl component="fieldset" className={classes.w100}>
              <FormLabel component="legend" className={classes.subText}>
                Choose a theme
              </FormLabel>
              <RadioGroup
                aria-label="variant"
                name="variant"
                value={Number(selectedTheme)}
                onChange={(event) => setSelectedTheme(event.target.value)}
              >
                <FormLabels />
              </RadioGroup>
            </FormControl>
          </div>
        </ExpansionPanelDetails>
        <Divider />
        <AccordionActions>
          <Button
            size="small"
            onClick={() => handleThemeChange('cancel')}
            disabled={theme === selectedTheme}
          >
            Cancel
          </Button>
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={() => handleThemeChange('save')}
            disabled={theme === selectedTheme}
          >
            Save
          </Button>
        </AccordionActions>
      </ExpansionPanel>
    </div>
  );
};

export default ThemeSettings;
